module.exports = __webpack_public_path__ + "assets/img/back-4.230787c5.png";